import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-model-details',
    templateUrl: './model-details.component.html',
    styleUrls: ['./model-details.component.scss'],
    standalone: false
})
export class ModelDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
